const FeeComponent = ({ data }) => {
    const contracts = data?.details?.contracts || [];
    return (
        <>
            <p style={{ fontSize: "1.2rem", fontWeight: "600", padding: "1rem 0rem 1rem 0rem" }}>{data?.feeComponentName}</p>
            <p className="sub-title">{data?.description}</p>
            {contracts.length ? (
                <>
                    <p style={{ fontSize: "1.2rem", fontWeight: "600", padding: "1rem 0rem 1rem 0rem" }}>Supplier contracts</p>
                    <div className="table-wrapper" style={{ height: "auto", maxHeight: "unset" }}>
                        <table>
                            <thead>
                                <tr>
                                    <th>name</th>
                                    <th>status</th>
                                    <th>supplierHccId</th>
                                    <th>supplierName</th>
                                    <th>supplierNetworkName</th>
                                    <th>subContractFeeSchedType</th>
                                </tr>
                            </thead>
                            <tbody>
                                {contracts.map((r, i) => (
                                    <tr key={'sc' + (r.key || i)}>
                                        <td>{r.name}</td>
                                        <td>{r.status}</td>
                                        <td>{r.supplierHccId}</td>
                                        <td>{r.supplierName}</td>
                                        <td>{r.supplierNetworkName}</td>
                                        <td>{r.subContractFeeSchedType}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            ) : (
                <p className="sub-title">No supplier contracts currently attach this fee component.</p>
            )}
        </>
    );
};

export default FeeComponent;
